// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDirectDepositDto
 */
export interface IDirectDepositDto {
    /**
     * 
     * @type {string}
     * @memberof IDirectDepositDto
     */
    account_description?: string;
    /**
     * Should be encrypted with RSAES_OAEP_SHA_1 algorithm in base64 format
     * @type {string}
     * @memberof IDirectDepositDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectDepositDto
     */
    account_routing_transit_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectDepositDto
     */
    account_category?: IDirectDepositDtoAccountCategoryEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDirectDepositDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IDirectDepositDto interface.
 */
export function instanceOfIDirectDepositDto(value: object): value is IDirectDepositDto {
    return true;
}

export function IDirectDepositDtoFromJSON(json: any): IDirectDepositDto {
    return IDirectDepositDtoFromJSONTyped(json, false);
}

export function IDirectDepositDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDirectDepositDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'account_routing_transit_number': json['account_routing_transit_number'] == null ? undefined : json['account_routing_transit_number'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
    };
}

export function IDirectDepositDtoToJSON(json: any): IDirectDepositDto {
    return IDirectDepositDtoToJSONTyped(json, false);
}

export function IDirectDepositDtoToJSONTyped(value?: IDirectDepositDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_description': value['account_description'],
        'account_number': value['account_number'],
        'account_routing_transit_number': value['account_routing_transit_number'],
        'account_category': value['account_category'],
    };
}

